export default __webpack_public_path__ + "static/media/border.149e6e5a.svg";